module.exports = __webpack_public_path__ + "img/health2.53fe7921.jpg";